export const works = [
  {
    id: "Expressions-work",
    title: "Expressions",
    year: "2026",
    location: "",
    duration: "",
    status: "",
    technology: ["Servo Motor, Camera, Raspberry Pi "],
    output: "A puppet head with moving features, real-time, mimicking the human facial expressions that it sees.",
    description: "A social installation where people can engage with a familiar-looking face that mirrors their own emotions, creating an interactive and immersive experience for users. The work explores themes of identity, empathy, and the humanization of technology, inviting visitors to reflect on their own expressions and emotions as they interact with the installation.",
    longDescription: "This project explores what it means to be human through the lens of artificial intelligence embodied in a physical form. By observing and interpreting human facial expressions in real time, the system learns to mimic and respond to the emotions it perceives, much like a child learning from its surroundings. It exists as an experiment in how AI can move beyond abstract computation into a tangible, interactive presence—reflecting human behavior, emotions, and social cues through both digital intelligence and physical response.",
    tags: ["Animatronics", "Movement", "Vision"],
    subtitle: "On reflecting one's facial expressions.",
    date: "2026-04-27",
    readTime: "8 min",
    workId: "Expressions-work",
    excerpt: "Mimicking the way people show expresions on their face. A puppet that moves its facial features to reflect what it sees.",
    writingId: "expressions-blog",
    hasPhotos: true,
    hasSketches: false,
    num: "01",
    coverImage: "/img/blog/Expressions-blog-cover.jpg",

  },

  {
    id: "phantom-lines-work",
    title: "Phantom Lines",
    year: "2025",
    location: "",
    duration: "",
    status: "",
    technology: ["Phone", "Position / orientation tracking, Unity, AR"],
    output: "A physical-analogue data device prototype that detects virtual boundaries in the real world.",
    description: "A sensor-based device that allows users to perceive and interact with invisible virtual boundaries in the physical world. The device translates digital data into tangible feedback, enabling users to explore and understand the unseen aspects of their environment.",
    longDescription: "",
    subtitle: "On making the invisible, visible.",
    date: "2025-12-01",
    readTime: "8 min",
    tags: ["Light","Movement","Sensors"],
    workId: "phantom-lines-work",
    excerpt: "Sensing the unseen. The idea for this  physical-analogue data device prototype was creating a hand that can detect the virtual world",
    writingId: "phantom-lines-blog",
    hasPhotos: false,
    hasSketches: false,
    num: "02",
    coverImage: "/img/blog/phantom-lines-blog-cover.jpg",
  },

  {
    id: "pyramid-of-elements-work",
    title: "Pyramid of Elements",
    year: "2025",
    location: "",
    duration: "",
    status: "",
    technology: ["Rotary Encoder", "Lights"],
    output: "Light installation controlled by rotary encoders",
    description: "A grid of light responds to physical rotations on a separate device. Each LED's brightness is determined by a sine wave that simulates the elements of life — fire, earth, water, air — creating a dynamic interplay of color and movement.",
    longDescription: "A 6×12 grid of LED display set upon an installation called Vespera, developed from the Connected Environments Team from Center for Advanced Spatial Analysis (CASA) under The Bartlett School of Architecture. This responds to physical rotations done on a seperate device designed and developed. The final light-state of each LED is a Sine wave output that resprests the elements of life, Red, Green, Blue and a ambiant mix of colours wave simulation for Fire, Earth, Water and Air. The work explores the relationship between physical interaction and digital output, creating a dynamic and immersive experience for visitors.",
    subtitle: "On controlling lights display through constant change.",
    date: "2025-10-15",
    readTime: "8 min",
    tags: ["Rotary Encoder","Lights","Device"],
    workId: "pyramid-of-elements-work",
    excerpt: "Is it possible to capture the constant physical changes in our environment that’s backed by metrics and visually appealing enough whilst blurring the lines between technical and creative progress?",
    writingId: "pyramid-of-elements-blog",
    hasPhotos: false,
    hasSketches: false,
    num: "03",
    coverImage: "/img/blog/pyramid-of-elements-blog-cover.jpg",
  },


  {
    id: "movements-work",
    title: "Movements",
    year: "2026",
    location: "UCL, London",
    duration: "2 weeks",
    status: "Exhibited",
    sensors: ["Camera"],
    output: "An interctive grid of metallic tiles that tilt to show where someone is standing in the space, creating a dynamic and responsive environment.",
    description: "An arts-led kinetic data physicalization display peice of how people navigate and move around in the built environment. Movements is a non-invasive visitor presence and motion representation mapped to the exact position of them in the space where they exist. Changing how we perceive information about the spaces we build.",
    longDescription: "",
    subtitle: "On reflecting one's facial expressions.",
    date: "2026-07-16",
    readTime: "8 min",
    tags: ["Mechanics","kinetics","Data Physicalization"],
    workId: "movements-work",
    excerpt: "Mimicking the way people show expresions on their fce. A puppet that moves its facial features to reflect what it sees.",
    writingId: "Movements-blog",
    hasPhotos: false,
    hasSketches: false,
    num: "05",
    coverImage: "/img/works/movements-work-cover.jpg",
    coverImageHome: "../images/works_img/movements-main.jpeg"
  },

  {
    id: "",
    title: "The Self-Portrait of an AI",
    year: "",
    location: "",
    duration: "",
    status: "",
    sensors: [],
    output: "",
    description: "",
    longDescription: "",
    subtitle: "On the meaning of self, creativity and what defines these for AI system?",
    date: "2026-06-08",
    readTime: "8 min",
    tags: ["Rotary Encoder","Lights","Device"],
    workId: "the-self-portrait-of-an-AI-work",
    excerpt: "When artists make self-portraits, it is a reproduction of lived experiences, shared knowledge, observations of the world, self-identity and intuition- an element generated through time.",
    writingId: "the-self-portrait-of-an-AI-blog",
    hasPhotos: false,
    hasSketches: false,
    num: "06",
    coverImage: "/img/blog1.png",
  },

  {
    id: "",
    title: "",
    year: "",
    location: "",
    duration: "",
    status: "",
    sensors: [],
    output: "",
    description: "",
    longDescription: "",
    subtitle: "",
    date: "",
    readTime: "",
    tags: [],
    workId: "",
    excerpt: "",
    writingId: "",
    hasPhotos: false,
    hasSketches: false,
    num: "",
    coverImage: "",
  },

  {
    id: "",
    title: "",
    year: "",
    location: "",
    duration: "",
    status: "",
    sensors: [],
    output: "",
    description: "",
    longDescription: "",
    subtitle: "",
    date: "",
    readTime: "",
    tags: [],
    workId: "",
    excerpt: "",
    writingId: "",
    hasPhotos: false,
    hasSketches: false,
    num: "",
    coverImage: "",
  },

  {
    id: "",
    title: "",
    year: "",
    location: "",
    duration: "",
    status: "",
    sensors: [],
    output: "",
    description: "",
    longDescription: "",
    subtitle: "",
    date: "",
    readTime: "",
    tags: [],
    workId: "",
    excerpt: "",
    writingId: "",
    hasPhotos: false,
    hasSketches: false,
    num: "",
    coverImage: "",
  },
];
